import React from 'react';

const panels = [
  { title: 'Abitare Giovane', text: 'Proposta di legge popolare per il diritto alla casa.', bg: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.8)), url(https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=800&auto=format&fit=crop)' },
  { title: 'Salute Mentale', text: 'Psicologo di base in ogni regione italiana.', bg: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.8)), url(https://images.unsplash.com/photo-1527137342181-19aab11a8ee8?q=80&w=800&auto=format&fit=crop)' },
  { title: 'Lavoro Giusto', text: 'Abolizione stage gratuiti e salario minimo legale.', bg: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.8)), url(https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=800&auto=format&fit=crop)' },
  { title: 'Transizione Ecologica', text: 'Per un paese verde, equo e sostenibile.', bg: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.8)), url(https://images.unsplash.com/photo-1466611653911-95081537e5b7?q=80&w=800&auto=format&fit=crop)' },
];

const HorizontalScroll = () => {
  return (
    <section className="horizontal-scroll-section">
      <div className="horizontal-pin-wrap">
        <div className="horizontal-scroll-container">
          {/* Intro Panel */}
          <div className="h-panel h-panel--intro">
            <article className="h-card" style={{ background: 'linear-gradient(rgba(122,31,28,0.4), rgba(122,31,28,0.8)), url(https://images.unsplash.com/photo-1529156069898-49953eb1b5ae?q=80&w=1200&auto=format&fit=crop) center/cover no-repeat', justifyContent: 'center' }}>
              <h2 className="h2 mb-4" style={{ color: '#fff', position: 'relative', zIndex: 1 }}>Le nostre battaglie</h2>
              <p className="subtitle" style={{ color: 'rgba(255,255,255,0.9)', position: 'relative', zIndex: 1 }}>
                Scorri per scoprire i temi su cui siamo impegnati ogni giorno in tutta Italia.
              </p>
            </article>
          </div>
          {/* Cards */}
          {panels.map((panel) => (
            <div className="h-panel h-panel--card" key={panel.title}>
              <article className="h-card">
                <div className="h-card__img" style={{ backgroundImage: panel.bg, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                <h3>{panel.title}</h3>
                <p>{panel.text}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HorizontalScroll;
